/**
 * Checks if all items in an array have vertical orientation
 */
export const areAllItemsVertical = <
  T extends { stockItem?: { isVertical?: boolean } },
>(
  items: T[]
): boolean => {
  return items.length > 0 && items.every((item) => item.stockItem?.isVertical);
};
